import { Filter } from './filter.js';
import * as glMatrix from '../../../../node_modules/gl-matrix/esm';

export class ColorBalanceFilter extends Filter {
    _preserve_luminosity: boolean;
    _tone: number;
    _highlights: glMatrix.vec3 | number;
    _midtones: glMatrix.vec3 | number;
    _shadows: glMatrix.vec3 | number;
    minRed: number;
    maxRed: number;
    minGreen: number;
    maxGreen: number;
    minBlue: number;
    maxBlue: number;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'colorBalance', 'Balance des couleurs');
        var self = this;
        self._preserve_luminosity = true;
        self._tone = 1;
        self._highlights = glMatrix.vec3.create();
        self._midtones = glMatrix.vec3.create();
        self._shadows = glMatrix.vec3.create();
        self.reset();
    }

    get preserve_luminosity() {
        return this._preserve_luminosity;
    }

    set preserve_luminosity(value) {
        var self = this;
        self._preserve_luminosity = value;
        self._touch = true;
    }

    get tone() {
        return this._tone;
    }

    set tone(value) {
        var self = this;
        self._tone = value;
        self._touch = true;
    }

    get highlights() {
        return this._highlights;
    }

    get midtones() {
        return this._midtones;
    }

    get shadows() {
        return this._shadows;
    }

    get red() {
        var self = this;
        switch (self.tone) {
            case 0:
                return self._shadows[0];
            case 1:
                return self._midtones[0];
            case 2:
                return self._highlights[0];
        }
    }

    set red(value) {
        var self = this;
        switch (self.tone) {
            case 0:
                self._shadows[0] = value;
                break;
            case 1:
                self._midtones[0] = value;
                break;
            case 2:
                self._highlights[0] = value;
                break;
        }
        self._touch = true;
    }

    get green() {
        var self = this;
        switch (self.tone) {
            case 0:
                return self._shadows[1];
            case 1:
                return self._midtones[1];
            case 2:
                return self._highlights[1];
        }
    }

    set green(value) {
        var self = this;
        switch (self.tone) {
            case 0:
                self._shadows[1] = value;
                break;
            case 1:
                self._midtones[1] = value;
                break;
            case 2:
                self._highlights[1] = value;
                break;
        }
        self._touch = true;
    }

    get blue() {
        var self = this;
        switch (self.tone) {
            case 0:
                return self._shadows[2];
            case 1:
                return self._midtones[2];
            case 2:
                return self._highlights[2];
        }
    }

    set blue(value) {
        var self = this;
        switch (self.tone) {
            case 0:
                self._shadows[2] = value;
                break;
            case 1:
                self._midtones[2] = value;
                break;
            case 2:
                self._highlights[2] = value;
                break;
        }
        self._touch = true;
    }

    reset() {
        var self = this;
        self._touch = true;
        self._preserve_luminosity = true;
        self._tone = 1;

        self._highlights = glMatrix.vec3.create();
        self.minRed = -100;
        self.maxRed = 100;

        self._midtones = glMatrix.vec3.create();
        self.minGreen = -100;
        self.maxGreen = 100;

        self._shadows = glMatrix.vec3.create();
        self.minBlue = -100;
        self.maxBlue = 100;
    }

}
